import {Enumify} from 'enumify-ts';

class FreightItemFormType extends Enumify<FreightItemFormType>() {

    static PALLET = new FreightItemFormType("Pallet");
    static CARTON = new FreightItemFormType("Carton");
    static ITEM = new FreightItemFormType("Item");
    static QUANTITY_EACH = new FreightItemFormType("Each");
    static CONTAINER = new FreightItemFormType("Container");
    static CRATE = new FreightItemFormType("Create");
    static CASK = new FreightItemFormType("Cask");
    static ROLL = new FreightItemFormType("Roll");
    static UNITS = new FreightItemFormType("Units");
    static BULKA_BAG = new FreightItemFormType("Bulka Bag");
    static _ = FreightItemFormType._closeEnum();

    constructor(
        public description: string
    ) {
        super();
    }

}

export default FreightItemFormType;
